<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">营销管理>扫码领券</div>
		<div class="title">
			<div class="right">
				<router-link to="/newScan">
					<el-button type="primary" size="small" style="margin-bottom: 20px;">新建扫码领券</el-button>
				</router-link>
			</div>
		</div>
		<el-table :cell-style="{'text-align':'center'}"
			:header-cell-style="{background:'#F2F2F4','text-align':'center'}" :data="tableData" ref="multipleTable"
			tooltip-effect="dark" style="width: 100%">
			<el-table-column prop="id" label="id" width="100px"></el-table-column>
			<el-table-column prop="name" label="名称" width="200px"></el-table-column>
			<el-table-column prop="image" label="背景图">
				<template slot-scope="scope">
					<el-image :src="scope.row.image" style="width: 125px; height: 200px;"></el-image>
				</template>
			</el-table-column>
			<el-table-column prop="qrCode" label="二维码">
				<template slot-scope="scope">
					<el-image :src="scope.row.qrCode" style="width: 150px; height: 150px;"></el-image>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="url" label="跳转链接" width="200px">
			</el-table-column> -->
			<el-table-column prop="couponId" label="优惠券/券包ID" width="150px"></el-table-column>
			<el-table-column label="操作" width="100px">
				<template slot-scope="scope">
					<el-button type="text" @click="deit(scope.row.id)" style="font-size: 16px;">编辑</el-button>
					<!-- 					<el-popconfirm title="确定删除吗？" @onConfirm="deleteById(scope.row.id)">
					<el-button type="text" size="mini" slot="reference" style="margin-left: 10px;color: red; font-size: 16px;">删除</el-button>
					</el-popconfirm> -->
					<!-- <el-button type="text" size="mini" @click="deleteById(scope.row.id)" slot="reference" style="margin-left: 10px;color: red; font-size: 16px;">删除</el-button> -->
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>
<script>
	import upload from "../../compents/upload/upload";
	export default {
		components: {
			upload
		},
		data() {
			return {
				tableData: []
			}
		},
		mounted() {
			this.getList();
		},
		methods: {
			getList() {
				this.$http.get("marketing/listScan").then(res => {
					this.tableData = res.body.data;
				})
			},
			deit(id) {
				this.$router.push({
					path: 'newScan',
					query: {
						id: id
					}
				})
			},
			deleteById(id) {
				this.$http.get("marketing/delete" + "?id=" + id).then(res => {
					if (res.body.code == 200) {
						this.$message.success("删除成功");
						this.getList();
					}
				})
			}
		}
	};
</script>

<style>
</style>